export default __webpack_public_path__ + "static/media/prediction.2ae1d6f9.gif";